import {useSelector} from 'react-redux';
import {Navigate, Outlet} from 'react-router-dom';
import * as React from "react";
import {RootState} from "./store";

const PrivateAdminRoute = () => {
    const [isLogged, isAdmin] = useSelector((state: RootState) => {
        return [state.login.isLogged, state.login.isAdmin]
    })

    if (!isLogged && !isAdmin) {
        return <Navigate to="/home"/>
    }

    return <Outlet />
}

export default PrivateAdminRoute
